module.exports = __webpack_public_path__ + "static/img/question.9c285948.svg";